export const SET_USER = 'setUser';
export const LOADING = 'setLoading';
